import { Component, Input } from '@angular/core';
import { Customer, Gender } from '../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../services/customer/customer.service';

@Component({
  selector: 'app-create-new-customer-modal',
  templateUrl: './create-new-customer-modal.component.html',
  styleUrls: ['./create-new-customer-modal.component.css']
})
export class CreateNewCustomerModalComponent {

  @Input() savedCallback: (createdCustomer: Customer) => undefined;

  public firstName = '';
  public lastName = '';
  public birthday = '';
  public email = '';
  public sendEmailInvite = true;

  public loadingSubmit = false;

  public genericErrorMessage = '';
  public existingCustomerWithBasicInfoId: number = null;
  public existingCustomerWithEmailId: number = null;
  public existingCustomerWithEmailFirstName = '';
  public existingCustomerWithEmailLastName = '';
  public serverError: number = null;

  public Gender = Gender;

  constructor(
    public activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  public handleSubmit() {
    this.genericErrorMessage = '';
    this.existingCustomerWithBasicInfoId = null;
    this.existingCustomerWithEmailId = null;
    this.existingCustomerWithEmailFirstName = '';
    this.existingCustomerWithEmailLastName = '';

    const missingRequired = (
      (this.firstName === '') ||
      (this.lastName === '') ||
      (this.birthday === '')
    );

    if (missingRequired) {
      this.genericErrorMessage = 'First Name, Last Name, and Birthday are required.';
      return;
    }

    this.loadingSubmit = true;

    this.customerService
      .createNewCustomer(
        this.firstName,
        this.lastName,
        this.birthday,
        this.email,
        this.sendEmailInvite
      )
      .then(newCustomer => {
        this.savedCallback(newCustomer);
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          const errorType: string = reason.error.error_type;
          if (errorType === 'generic') {
            this.genericErrorMessage = reason.error.error_message;
          } else if (errorType === 'existing_customer_with_basic_info') {
            this.existingCustomerWithBasicInfoId = reason.error.customer_id;
          } else if (errorType === 'existing_customer_with_email') {
            this.existingCustomerWithEmailId = reason.error.customer_id;
            this.existingCustomerWithEmailFirstName = reason.error.customer_first_name;
            this.existingCustomerWithEmailLastName = reason.error.customer_last_name;
          }
        } else if (reason.status === 403) {
          this.genericErrorMessage = 'You do not have permission to create customers.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
